import React from 'react'

import Pagination from './Pagination'
import Page from './Page'

class Mandate extends React.Component {
	constructor() {
		super()

		this.state = {
			mandates: [
				'To be an organization run by people with disabilities to empower people with disabilities',
				'To collaborate with stakeholders to promote the rights of people with disabilities for them to take control of their own lives through increased knowledge and examination of options, making informed choices, and taking calculated risks ',
				'To offer opportunities for people with disabilities to learn skills necessary for successful inclusion into the society, including social and economic opportunities',
				'To develop and implement services, programs and activities that empower people',
				'To continue to expand mutual and complementary partnerships and responsibilities'
			],
			currentPage: null
		}
	}

	onPageChanged = data => {
		const { currentPage, totalPages } = data
		this.setState({ currentPage, totalPages })
	}

	render() {
		const {
			mandates,
			currentPage,
			totalPages
		} = this.state
		const totalMandates = mandates.length

		if (totalPages === 0) return null

		return (
			<>
				{currentPage && <Page page={currentPage} text={mandates[currentPage-1]} />}
				<Pagination total={totalMandates} onPageChanged={this.onPageChanged} />
			</>
		)
	}
}

export default Mandate
